import React, { Component } from "react";
import TrackingArtwork from "../trackingArtwork";

class completedMap extends Component {
  render() {
    const { booking } = this.props;

    return (
      <TrackingArtwork
        isMaxService={booking?.trip?.service?.isMaxService}
        title="Trip is completed"
        subtitle="Hope you had a great journey"
      />
    );
  }
}

export default completedMap;
